// src/data/examQuestions.js
// Spłaszczony indeks wszystkich pytań egzaminacyjnych - jedno źródło dla
// podstron /pytania/<slug>, linkowania wewnętrznego, mapy strony i prerenderu.
import { EXAM_PARTS } from './examParts';
import { EXAM_EXPLANATIONS } from './examExplanations';

/** Pytania w kolejności występowania, z kontekstem części i sekcji. */
export const ALL_QUESTIONS = EXAM_PARTS.flatMap(part =>
  part.sections.flatMap(section =>
    section.questions.map(question => ({
      ...question,
      partPath: part.path,
      partNumber: part.part,
      partTitle: part.h1,
      sectionId: section.id,
      sectionHeading: section.heading,
      explanation: EXAM_EXPLANATIONS[question.slug] || null,
    }))
  )
);

// Numer porządkowy w obrębie części - pokazywany na kartach i podstronach.
ALL_QUESTIONS.forEach(question => {
  const inPart = ALL_QUESTIONS.filter(q => q.partPath === question.partPath);
  question.numberInPart = inPart.indexOf(question) + 1;
  question.questionsInPart = inPart.length;
});

export const questionPath = slug => `/pytania/${slug}`;

export const getQuestionBySlug = slug =>
  ALL_QUESTIONS.find(question => question.slug === slug) || null;

/** Sąsiednie pytania w obrębie tej samej części - nawigacja krok po kroku. */
export const getQuestionNeighbours = slug => {
  const index = ALL_QUESTIONS.findIndex(question => question.slug === slug);
  if (index === -1) return { prev: null, next: null };
  const current = ALL_QUESTIONS[index];
  const inPart = ALL_QUESTIONS.filter(q => q.partPath === current.partPath);
  const localIndex = inPart.indexOf(current);
  return {
    prev: localIndex > 0 ? inPart[localIndex - 1] : null,
    next: localIndex < inPart.length - 1 ? inPart[localIndex + 1] : null,
  };
};

/** Pozostałe pytania z tej samej sekcji - linkowanie tematyczne. */
export const getSiblingQuestions = slug => {
  const current = getQuestionBySlug(slug);
  if (!current) return [];
  return ALL_QUESTIONS.filter(
    question =>
      question.partPath === current.partPath && question.sectionId === current.sectionId
  );
};

/** Pełna lista adresów podstron - używana w prerenderze i mapie strony. */
export const QUESTION_PATHS = ALL_QUESTIONS.map(question => questionPath(question.slug));
